import axios from 'axios'


interface Response {
  status: string
  data: any
}


export const GeneralTextByDimensions = async (token: string) => {

  const apiTest = `${process.env.REACT_APP_MAIN_API}/general_text/competence`

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }


  // post get
  const response: Response = await axios.get(apiTest, config).then((res) => {
    return res.data
  }).catch((err) => {
    return err
  })

  return response
}
